(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q', '$rootScope', 'CompanySession'];

    function AuthServerProvider($http, $localStorage, $sessionStorage, $q, $rootScope, CompanySession) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken() {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login(credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe,
                captchaCode: credentials.captchaCode
            };
            var req = {
                method: 'POST',
                url: 'api/authenticate',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'

                },
                data: data
            }
            //    return $http.post('api/authenticate', data).success(authenticateSuccess);
            return $http(req).success(authenticateSuccess);

            function authenticateSuccess(data, status, headers) {

                CompanySession.resetCompanySession();

                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            $localStorage.authenticationToken = jwt;
            ///TODO : when remember me is off opening in new page will cause problem so temporarily we delet it


            //ca
            //if(rememberMe){
            //    $localStorage.authenticationToken = jwt;
            //} else {
            //    $sessionStorage.authenticationToken = jwt;
            //}
        }

        function logout() {

            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
            CompanySession.resetCompanySession();
            $rootScope.$broadcast('Logout');

        }
    }
})();
